import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { EnvironmentProviders, Provider } from '@angular/core';

import { AbstractSecurityStorage, authInterceptor, provideAuth as provideAuthOidc } from 'angular-auth-oidc-client';

import { environment } from 'environments/environment';

import { AuthLocalStorageService } from './auth-local-storage.service';

export const provideAuth = (): Array<Provider | EnvironmentProviders> => {
	return [
		provideHttpClient(withInterceptors([authInterceptor()])),
		provideAuthOidc({
			config: {
				configId: 'auth',
				triggerAuthorizationResultEvent: true,
				authority: environment.authUrl,
				redirectUrl: `${environment.basePortalUrl}/auth-callback`,
				clientId: 'marketplace_client',
				scope: 'openid profile email offline_access wine_portal_api',
				responseType: 'code',
				silentRenew: true,
				silentRenewUrl: `${environment.basePortalUrl}/silent-renew.html`,
				useRefreshToken: true,
				postLoginRoute: '/listings',
				postLogoutRedirectUri: `${environment.basePortalUrl}`,
				forbiddenRoute: '/forbidden',
				unauthorizedRoute: '/unauthorized',
				autoUserInfo: true,
				historyCleanupOff: true,
				renewTimeBeforeTokenExpiresInSeconds: 60,
				authWellknownEndpoints: {
					issuer: environment.authUrl,
					jwksUri: `${environment.authUrl}/.well-known/openid-configuration/jwks`,
					authorizationEndpoint: `${environment.authUrl}/connect/authorize`,
					tokenEndpoint: `${environment.authUrl}/connect/token`,
					userInfoEndpoint: `${environment.authUrl}/connect/userinfo`,
					endSessionEndpoint: `${environment.authUrl}/connect/endsession`,
					checkSessionIframe: `${environment.authUrl}/connect/checksession`,
					revocationEndpoint: `${environment.authUrl}/connect/revocation`,
					introspectionEndpoint: `${environment.authUrl}/connect/introspect`,
				},
				secureRoutes: [
					environment.billingUrl,
					environment.facilityManagementUrl,
					environment.marketplaceUrl,
					environment.paymentsUrl,
					environment.referenceDataUrl,
					environment.storageManagementUrl,
					environment.userManagementUrl,
				],
			},
		}),
		{
			provide: AbstractSecurityStorage,
			useClass: AuthLocalStorageService,
		},
	];
};
